export function foo() {}

export function getMatchOpponents(name: string): [string, string] {
  const [player1, player2] = name.split(/\s+VS?\s+/i);
  return [player1, player2];
}
